/*
 * Name: Monetate Server Side CS Integration
 * Version: 1.0.0
 */

import type { ExperimentDecisions } from '@johnlewispartnership/wtr-website-decisioner-client/types/Experiments';

import { isWindowAvailable } from 'constants/is-window-available';

let disableCallback = false;

function callback() {
  const version = '1.0.0';

  if (!disableCallback) {
    disableCallback = true;

    if (window.CS_CONF) {
      window.CS_CONF.integrations = window.CS_CONF.integrations ?? [];
      window.CS_CONF.integrations.push(`Monetate Server Side - v${version}`);
    }
  }
}

if (isWindowAvailable) {
  window._uxa = window._uxa ?? [];
  window._uxa.push(['afterPageView', callback]);
}

const tvp = 'AB_Mon_SS_';

function sendToCS(csKey: string, csValue: string) {
  if (window._uxa) {
    const newKey = tvp + csKey;
    window._uxa.push(['trackDynamicVariable', { key: newKey, value: csValue }]);
  }
}

const contentSquareReport = (experiments: ExperimentDecisions | null) => {
  if (!experiments) return;

  Object.values(experiments).forEach(experiment => {
    const { experienceLabel: campaignName, variantLabel: experienceName } = experiment;

    if (!campaignName || !experienceName) return;

    sendToCS(campaignName, experienceName);
  });
};

export default contentSquareReport;
